import { defineMessages } from "react-intl";

const messages = defineMessages({
  alert: {
    id: "reports.export.scheduleSend.alert",
    defaultMessage:
      "You will receive an initial email including all data that meet the filtering criteria. <b>Subsequent emails will only include information that has been added or modified since</b> the previous export. Take caution when using date or time filters on repeating exports.",
    description: "Alert content for schedule send export",
  },
  all: {
    id: "reports.exports.scheduleSend.all",
    defaultMessage: "All records",
    description: "All records",
  },
  allRecords: {
    id: "reports.export.scheduleSend.allRecords",
    defaultMessage:
      "Every export will include data from <b>all records that fit filter criteria</b>, even if nothing has changed on that record.",
    description: "Alert content for all records schedule send export",
  },
  cancel: {
    id: "reports.export.scheduleEditModal.cancel",
    defaultMessage: "Cancel",
    description: "Schedule Edit Modal Cancel button on the Export page",
  },
  dateTimeField: {
    id: "reports.export.scheduleEditModal.dateTimeField",
    defaultMessage: "Select a date and time",
    description: "DateTime field label on the Schedule Export page",
  },
  edit: {
    id: "reports.export.scheduleEditModal.title.edit",
    defaultMessage: "Edit Export",
    description: "Edit Modal Title on the Export page",
  },
  exportPreferences: {
    id: "reports.export.scheduleEditModal.exportPreferences",
    defaultMessage: "Export Preferences",
    description: "Schedule Edit Modal Export Preferences on the Export page",
  },
  greatForTeams: {
    id: "reports.export.scheduleSend.greatForTeams",
    defaultMessage:
      "Great for teams that want to schedule exports and get all the data each time during the export.",
    description: "Alert content for all records schedule send export",
  },
  newOrModified: {
    id: "reports.exports.scheduleSend.newOrModified",
    defaultMessage: "Only new or modified records",
    description: "Only new or modified records",
  },
  none: {
    id: "reports.export.scheduleEditModal.none",
    defaultMessage: "None",
    description: "Schedule Edit Modal None option on the Export page",
  },
  recipients: {
    id: "reports.export.scheduleEditModal.recipients",
    defaultMessage: "Recipients",
    description: "Recipients field label on the Export page",
  },
  saveChanges: {
    id: "reports.export.scheduleEditModal.saveChanges",
    defaultMessage: "Save changes",
    description: "Schedule Edit Modal Schedule button on the Export page",
  },
  schedule: {
    id: "reports.export.scheduleEditModal.title.schedule",
    defaultMessage: "Schedule Export",
    description: "Schedule Modal Title on the Export page",
  },
  scheduleExports: {
    id: "reports.export.scheduleEditModal.scheduleExports",
    defaultMessage: "Schedule Exports",
    description: "Schedule Edit Modal Schedule button on the Export page",
  },
  selectFrequency: {
    id: "reports.export.scheduleEditModal.selectFrequency",
    defaultMessage: "Select a frequency",
    description: "Frequency field label on the Export page",
  },
  selectTimezone: {
    id: "reports.export.scheduleEditModal.selectTimezone",
    defaultMessage: "Select timezone",
    description: "Timezone field label on the Export page",
  },
  stop: {
    id: "reports.export.scheduleEditModal.stop",
    defaultMessage: "Stop sending this export",
    description: "Schedule Edit Modal Stop sending this export button on the Export page",
  },
  validationRequired: {
    id: "reports.export.scheduleEditModal.dateTimeField.validation.required",
    defaultMessage: "Please enter a date and time",
    description: "Value required message for the DateTime field on Schedule Export modal",
  },
  withExample: {
    id: "reports.export.scheduleSend.alert.withExample",
    defaultMessage:
      "<b>Example:</b> If an Activity Export is set to run daily at 7 pm, Tuesday’s Report will include only the Activities logged or modified between Monday at 7 pm - Tuesday at 6:59 pm in the selected timezone.",
    description: "Alert content for schedule send export example",
  },
});

export default messages;
